module.exports = __webpack_public_path__ + "img/a8725cb076653957a52d4079b6465679.ba522607.jpg";